export default "__VITE_PUBLIC_ASSET__c038e7c5__"